import React from 'react'
import logocgmrio from '../images/logocgm40x40.png'
import UsuarioLogado from '../components/UsuarioLogado'
import FormDenunciaCGM from './FormDenunciaCGM'
import CorrespondenciaEntregue from './CorrespondenciaEntregue'
import Providencia from './Providencia'
import VisualizarProvidencias from './VisualizarProvidencias'
import Login from './Login'
import { obterPorDataAgora } from '../util/Data'
import { Form, Nav, Navbar } from 'react-bootstrap'

export default function Menu(props) {

    const showFormulario = (item, iniciarPrincipal = false, iniciarOutros = false) => {
        if (item === 'Denuncia') {
            props.setFormularioEmPauta('Denuncia');
            props.atuLinhaDoTempo('contato')
            props.setComplementacao('')
            props.iniciarCampos(iniciarPrincipal,iniciarOutros)
        } else if (item === 'Protocolo') {
            props.setFormularioEmPauta('Protocolo');
            props.atuLinhaDoTempo('protocolo')
            props.iniciarCampos(iniciarPrincipal,iniciarOutros)
        } else if (item === 'Narrativa') {
            props.setFormularioEmPauta('Narrativa');
            props.atuLinhaDoTempo('narrativa')
        } else if (item === 'VisualizarProvidencias') {
            props.setFormularioEmPauta('VisualizarProvidencias');
            props.atuLinhaDoTempo('visualizarProvidencias')
            props.iniciarCampos(iniciarPrincipal,iniciarOutros)
        } else if (item === 'CorrespondenciaEntregue') {
            props.atuLinhaDoTempo('correspondenciaEntregue')
            props.setFormularioEmPauta('CorrespondenciaEntregue');
        } else if (item === 'Login') {
            props.setFormularioEmPauta('Login');
            props.atuLinhaDoTempo('login')
            props.iniciarCampos(iniciarPrincipal,iniciarOutros)
        } else if (item === 'DenunciasGestor') {
            props.setFormularioEmPauta('CadastroDenuncias');
            props.atuLinhaDoTempo('cadastroDenuncias') 
        } else if (item === 'VisualizarDenuncias') {
            props.setFormularioEmPauta('VisualizarProvidencias');
            props.atuLinhaDoTempo('visualizarProvidencias')
            props.iniciarCampos(iniciarPrincipal,iniciarOutros)
            props.setUsuarioLogado({ ...props.usuarioLogado, logado:true })
        } else if (item === 'ProvidenciasGestor') {
            props.setFormularioEmPauta('ProvidenciasGestor');
            props.atuLinhaDoTempo('cadastroProvidencias') 
            props.iniciarCampos(iniciarPrincipal,iniciarOutros)
            props.setUsuarioLogado({ ...props.usuarioLogado, logado:true })
        } else if (item === 'Logout') {
            props.setUsuarioLogado({ login:'', nome:'', logado:false })
            props.iniciarCampos(iniciarPrincipal,iniciarOutros)
            props.setFormularioEmPauta('');
            props.atuLinhaDoTempo('protocolo') 
        } else if (item === '') {
            props.setFormularioEmPauta('');
            props.atuLinhaDoTempo('protocolo') 
        }
    }

    const renderLink = (frmEmPauta,rotulo,iniciarPrincipal,iniciarOutros) => {
        return(
            <Nav.Link 
                href="#" 
                className="text-primary my-auto" 
                onSelect={ () => showFormulario(frmEmPauta,iniciarPrincipal,iniciarOutros) }
            >
                { rotulo }
            </Nav.Link>
        )
    }

    const renderMenu = () => {
        if (props.usuarioLogado) {
            if (props.usuarioLogado.logado) {
                return(
                    <Navbar collapseOnSelect expand="sm" bg="light" fixed="top">
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="mr-auto">
                                { renderLink("VisualizarDenuncias","Visualizar denúncias",true,true) }
                                { renderLink("ProvidenciasGestor","Cadastrar providências",true,true) }
                            </Nav>
                            <Form inline>
                                { renderLink("Logout","logout",true,true) }
                            </Form>
                        </Navbar.Collapse>
                    </Navbar>
                )
            }
        }
        
        return(
            <Navbar collapseOnSelect expand="sm" bg="light" fixed="top">
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="mr-auto">
                        <img src={ logocgmrio } alt="Logo SITE Denúncia CGM.Rio" />
                        { renderLink("Denuncia","Denúncia",true,true) }
                        { renderLink("Protocolo","Complementação",true,true) }
                        { renderLink("VisualizarProvidencias","Acompanhamento",true,true) }
                    </Nav>
                    <Form inline>
                        { renderLink("Login","login",true,true) }
                    </Form>
                </Navbar.Collapse>
            </Navbar>
        )
    }

    return (
        <>
            { renderMenu() }
            <UsuarioLogado usuarioLogado={ props.usuarioLogado } />
            <FormDenunciaCGM 
                usuarioLogado={ props.usuarioLogado }
                showFormulario={ showFormulario }
                chamador={ props.chamador }
                iniciarCampos={ props.iniciarCampos }
                anonimato={ props.anonimato } setAnonimato={ props.setAnonimato }
                formularioEmPauta={ props.formularioEmPauta} setFormularioEmPauta={ props.setFormularioEmPauta }
                linhaDoTempo={ props.linhaDoTempo } atuLinhaDoTempo={ props.atuLinhaDoTempo }
                denuncia={ props.denuncia } setDenuncia={ props.setDenuncia }
                dadosPessoais={ props.dadosPessoais } setDadosPessoais={ props.setDadosPessoais }
                local={ props.local } setLocal={ props.setLocal }
                setMensagem={ props.setMensagem }
                dataAcontecimento={ props.dataAcontecimento} setDataAcontecimento={ props.setDataAcontecimento }
                pessoasEnvolvidas={ props.pessoasEnvolvidas} setPessoasEnvolvidas={ props.setPessoasEnvolvidas }
                links={ props.links} setLinks={ props.setLinks }
                anexosDto={ props.anexosDto } setAnexosDto={ props.setAnexosDto }
                protocolo={ props.protocolo } setProtocolo={ props.setProtocolo }
                mensagem={ props.mensagem } setMensagem={ props.setMensagem }
                atualizarAnexos={ props.atualizarAnexos} removerAnexos={ props.removerAnexos }
                setShowSpinner={ props.setShowSpinner }
                correspondenciaEntregue={ props.correspondenciaEntregue }
                setCorrespondenciaEntregue={ props.setCorrespondenciaEntregue } 
                showDenuncia={ props.showDenuncia } setShowDenuncia={ props.setShowDenuncia }
                complementacao={ props.complementacao } setComplementacao={ props.setComplementacao }
                conteudo={ props.conteudo } setConteudo={ props.setConteudo }
            />
            <CorrespondenciaEntregue
                usuarioLogado={ props.usuarioLogado }
                chamador={ props.chamador }
                showFormulario={ showFormulario } 
                linhaDoTempo={ props.linhaDoTempo } atuLinhaDoTempo={ props.atuLinhaDoTempo }
                correspondenciaEntregue={ props.correspondenciaEntregue }
                setCorrespondenciaEntregue={ props.setCorrespondenciaEntregue } 
                renderizarDenuncia={ props.renderizarDenuncia } 
                setRenderizarDenuncia={ props.setRenderizarDenuncia }
                complementacao={ props.complementacao }
                conteudo={ props.conteudo } 
                setShowSpinner={ props.setShowSpinner }
            />
            <VisualizarProvidencias 
                usuarioLogado={ props.usuarioLogado } 
                chamador={ props.chamador }
                showFormulario={ showFormulario }
                iniciarCampos={ props.iniciarCampos }
                linhaDoTempo={ props.linhaDoTempo } atuLinhaDoTempo={ props.atuLinhaDoTempo }
                correspondenciaEntregue={ props.correspondenciaEntregue }
                setCorrespondenciaEntregue={ props.setCorrespondenciaEntregue } 
                conteudo={ props.conteudo } setConteudo={ props.setConteudo }
                setMensagem={ props.setMensagem }
                setComplementacao={ props.setComplementacao }
                setShowSpinner={ props.setShowSpinner }
                renderizarDenuncia={ props.renderizarDenuncia } 
                setRenderizarDenuncia={ props.setRenderizarDenuncia }
                preencherLista={ obterPorDataAgora().milisegundosDesde1970 }
            />
            <Login 
                usuarioLogado={ props.usuarioLogado } setUsuarioLogado={ props.setUsuarioLogado }
                chamador={ props.chamador }
                showFormulario={ showFormulario }
                formularioEmPauta={ props.formularioEmPauta} setFormularioEmPauta={ props.setFormularioEmPauta }
                iniciarCampos={ props.iniciarCampos }
                linhaDoTempo={ props.linhaDoTempo } atuLinhaDoTempo={ props.atuLinhaDoTempo }
                correspondenciaEntregue={ props.correspondenciaEntregue }
                setCorrespondenciaEntregue={ props.setCorrespondenciaEntregue } 
                conteudo={ props.conteudo } setConteudo={ props.setConteudo }
                setMensagem={ props.setMensagem }
                setComplementacao={ props.setComplementacao }
                setShowSpinner={ props.setShowSpinner }
                renderizarDenuncia={ props.renderizarDenuncia } 
                setRenderizarDenuncia={ props.setRenderizarDenuncia }
            />
            <Providencia 
                chamador={ props.chamador }
                setShowSpinner={ props.setShowSpinner }
                formularioEmPauta={ props.formularioEmPauta} setFormularioEmPauta={ props.setFormularioEmPauta }
                setShowSpinner={ props.setShowSpinner }
                preencherLista={ obterPorDataAgora().milisegundosDesde1970 }
            />
        </>
    );
}